module.exports = __webpack_public_path__ + "statics/img/Hero-right.4a925390.png";